import React from 'react';
import PropTypes from 'prop-types';

export default function Area(_ref) {
  var layer = _ref.layer,
      area = _ref.area,
      catalog = _ref.catalog,
      unit = _ref.unit;


  var rendered = catalog.getElement(area.type).renderAxonomertic ? catalog.getElement(area.type).renderAxonomertic(area, layer) : null;

  return React.createElement(
    'g',
    null,
    rendered
  );
}

Area.propTypes = {
  area: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
  unit: PropTypes.string.isRequired
};